"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _react2.useTheme;
  }
});
Object.defineProperty(exports, "useMedia", {
  enumerable: true,
  get: function get() {
    return _reactUse.useMedia;
  }
});
exports.useDown = exports.useUp = exports.useBreakpoints = exports.useViewportWidth = void 0;

var _react = require("react");

var _react2 = require("@emotion/react");

var _reactUse = require("react-use");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';

var useViewportWidth = function useViewportWidth() {
  var _useState = (0, _react.useState)(isClient ? window.innerWidth : null),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return width;
};

exports.useViewportWidth = useViewportWidth;

var useBreakpoints = function useBreakpoints() {
  var _useTheme = (0, _react2.useTheme)(),
      breakpoints = _useTheme.breakpoints;

  return breakpoints;
};

exports.useBreakpoints = useBreakpoints;

var useUp = function useUp(breakpoint) {
  var breakpoints = useBreakpoints();
  var query = "(min-width: ".concat(breakpoints[breakpoint], ")");
  return (0, _reactUse.useMedia)(query);
};

exports.useUp = useUp;

var useDown = function useDown(breakpoint) {
  var breakpoints = useBreakpoints();
  var query = "(max-width: ".concat(breakpoints[breakpoint], ")");
  return (0, _reactUse.useMedia)(query);
};

exports.useDown = useDown;

//# sourceMappingURL=index.js.map